import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import {
  Button,
  Container,
  Nav,
  Navbar,
  Offcanvas,
  Form,
  Spinner,
} from "react-bootstrap";
import { useHistory, useLocation } from "react-router-dom";
import {
  SetLanguage,
  fetchDataFromDatabase,
  formatCurrency,
  getAccessTokkenFromLCS,
  getUserDataFromLCStorage,
  useAuth,
} from "../helper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMoneyBill1Wave,
  faClose,
  faHomeLg,
  faUserPlus,
  faRightToBracket,
  faRightFromBracket,
  faHistory,
  faUser,
  faSackDollar,
  faSearch,
  faGlobe,
} from "@fortawesome/free-solid-svg-icons";
import Consts, { URL_IMAGE } from "../consts";
import { SERVER_URL } from "../api/index";
import { useTranslation } from "react-i18next";
import { encryptData } from "../utils/encrypt";

export default function NaveBar() {
  const { i18n } = useTranslation();
  const { t } = useTranslation();
  const location = useLocation();
  const history = useHistory();
  const isAuthenticated = useAuth();

  const [dataLogin, setDataLogin] = useState();
  const [dataUser, setDataUser] = useState();
  const [languageLocal, setLanguageLocal] = useState();
  const [isShowSideNav, setIsShowSideNav] = useState(false);
  const [selected, setSelected] = useState();
  const [customerMoney, setCustomerMoney] = useState(0);
  const [customerName, setCustomerName] = useState("");
  const [tagsShow, setTagsShow] = useState(false);
  const [inputValue, setInputValue] = useState();
  const [dataFilter, setDataFilter] = useState([]);

  const [countTimeSearch, setCountTimeSearch] = useState(0);
  const [loadingSearch, setLoadingSearch] = useState(false);

  const languageFlags = {
    lo: "/assets/uploads/logo/lao.svg",
    th: "/assets/uploads/logo/thai.svg",
    en: "/assets/uploads/logo/unit.svg",
    vi: "/assets/uploads/logo/vietnam.svg",
    zh: "/assets/uploads/logo/china.svg",
    km: "/assets/uploads/logo/cambodia.svg",
    my: "/assets/uploads/logo/myanmar.svg",
    id: "/assets/uploads/logo/indonesia.svg",
  };

  useEffect(() => {
    // Set a timeout to update the state after 2 seconds (2000 ms)
    if (countTimeSearch <= 0) {
      return;
    }
    const timer = setTimeout(() => {
      setCountTimeSearch(countTimeSearch - 1);
    }, 1000);

    // Cleanup the timeout if the component unmounts or count changes
    return () => clearTimeout(timer);
  }, [countTimeSearch]); // Dependency array with count to re-run on count change

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  useEffect(() => {
    if (countTimeSearch == 0) {
      if (inputValue) _filterData();
    }
  }, [inputValue, countTimeSearch]);
  useEffect(() => {
    const _Language = JSON.parse(localStorage.getItem("Language"));
    if (!_Language) {
      SetLanguage("lo");
    }
    i18n.changeLanguage(_Language);
    if (_Language) {
      setLanguageLocal(_Language);
    }
    setSelected(location.pathname.split("/")[1]);
  }, [location]);
  // console.log("selected==>", selected)
  // ★ Cache user data 30 ວິນາທີ ເພື່ອບໍ່ fetch ທຸກຄັ້ງທີ່ navigate
  const userCacheRef = useRef({ data: null, ts: 0 });
  const USER_CACHE_TTL = 30 * 1000; // 30 ວິນາທີ (ສັ້ນ ເພາະ balance ສຳຄັນ)

  useEffect(() => {
    const _Language = JSON.parse(localStorage.getItem("Language"));
    i18n.changeLanguage(_Language);
    if (_Language) {
      setLanguageLocal(_Language);
    }
    if (isAuthenticated) {
      const userData = getUserDataFromLCStorage();
      if (!userData?._id) return;

      // ★ ເຊັກ cache ກ່ອນ fetch
      const now = Date.now();
      if (userCacheRef.current.data && (now - userCacheRef.current.ts) < USER_CACHE_TTL) {
        const cached = userCacheRef.current.data;
        setDataUser(cached);
        setCustomerMoney(cached.walletAmount);
        setCustomerName(cached.name);
        setDataLogin(true);
        return;
      }

      const fetchDataUser = async () => {
        let _getData = await axios.get(
          `${SERVER_URL}/api/v1/user/${userData?._id}`,
          {
            headers: {
              Authorization: getAccessTokkenFromLCS(),
              "x-encrypted": encryptData({
                timestamp: new Date().getTime(),
              }),
            },
          }
        );
        if (_getData?.data) {
          setDataUser(_getData?.data);
          setCustomerMoney(_getData?.data?.walletAmount);
          setCustomerName(_getData?.data?.name);
          setDataLogin(true);
          // ★ ເກັບ cache
          userCacheRef.current = { data: _getData.data, ts: Date.now() };
        }
      };
      fetchDataUser();
    }

    // ===== ຟັງ event ອັບເດດຍອດເງິນແບບ real-time =====
    const handleBalanceUpdate = () => {
      // ★ ລ້າງ cache ເມື່ອ balance ປ່ຽນ
      userCacheRef.current = { data: null, ts: 0 };
      if (isAuthenticated) {
        const ud = getUserDataFromLCStorage();
        if (!ud?._id) return;
        axios.get(
          `${SERVER_URL}/api/v1/user/${ud._id}`,
          {
            headers: {
              Authorization: getAccessTokkenFromLCS(),
              "x-encrypted": encryptData({
                timestamp: new Date().getTime(),
              }),
            },
          }
        ).then(res => {
          if (res?.data) {
            setDataUser(res.data);
            setCustomerMoney(res.data.walletAmount);
            // ★ ອັບເດດ cache ດ້ວຍ data ໃໝ່
            userCacheRef.current = { data: res.data, ts: Date.now() };
          }
        }).catch(console.log);
      }
    };
    window.addEventListener('balance-updated', handleBalanceUpdate);
    return () => {
      window.removeEventListener('balance-updated', handleBalanceUpdate);
    };
  }, [isAuthenticated]);

  const _filterData = async () => {
    try {
      setLoadingSearch(true);
      let _getData = await await axios.get(
        `${SERVER_URL}/api/v1/game-filter?name=${inputValue}`,
        {
            headers: {
              Authorization: getAccessTokkenFromLCS(),
              "x-encrypted": encryptData({
                timestamp: new Date().getTime(),
              }),
            },
          }
      );
      if (_getData?.data) {
        setDataFilter(_getData?.data);
      }
    } catch (error) {
      console.log(
        "🚀 ~ file: CustomNavbar.js:55 ~ const_filterData=async ~ error:",
        error
      );
    } finally {
      setLoadingSearch(false);
    }
  };
  const changeLanguage = (lng) => {
    SetLanguage(lng);
    const _Language = JSON.parse(localStorage.getItem("Language"));
    i18n.changeLanguage(_Language);
    handleClose();
    window.location.reload();
  };
  const _ClickDetail = (data, value) => {
    setInputValue("");
    setTagsShow(false);
    history.push(`${Consts.GAME_DETAIL}/${data?._id}/` + value);
  };

  useEffect(() => {
    if (!tagsShow) {
      setInputValue();
      setDataFilter([]);
    }
  }, [tagsShow]);

  return (
    <div style={{ position: "sticky", top: 0, zIndex: 10 }}>
      <header className="header">
        <div
          className="logo"
          onClick={() => history.push(Consts.PAGE_HOME)}
          style={{ cursor: "pointer" }}
        >
          <img
            src={process.env.PUBLIC_URL + "/assets/uploads/logo/logo.png"}
            alt="Logo"
            onClick={() => history.push(Consts.PAGE_HOME)}
            style={{
              height: "40px",
            }}
          />
        </div>

        {/* === Desktop Navigation (hidden on mobile via CSS) === */}
        <nav className="desktop-nav">
          <div
            className={`desktop-nav-link${!selected || selected === '' ? ' active' : ''}`}
            onClick={() => history.push(Consts.PAGE_HOME)}
          >
            <FontAwesomeIcon icon={faHomeLg} className="nav-icon" />
            {t("FootterHome")}
          </div>
          {dataLogin && (
            <>
              <div
                className={`desktop-nav-link${['history-games', 'history-invoice', 'history-recharge'].includes(selected) ? ' active' : ''}`}
                onClick={() => history.push(Consts.HISTORY_GAME_INVOICE + '/limit/20/skip/1')}
              >
                <FontAwesomeIcon icon={faHistory} className="nav-icon" />
                {t("FootterHistory")}
              </div>
              <div
                className={`desktop-nav-link${selected === 'recharge' ? ' active' : ''}`}
                onClick={() => history.push(Consts.RECHARGE)}
              >
                <FontAwesomeIcon icon={faSackDollar} className="nav-icon" />
                {t("FootterMoney")}
              </div>
              <div
                className={`desktop-nav-link${selected === 'profile' || selected === 'change-password' ? ' active' : ''}`}
                onClick={() => history.push(Consts.PROFILE)}
              >
                <FontAwesomeIcon icon={faUser} className="nav-icon" />
                {t("FootterProfile")}
              </div>
            </>
          )}
        </nav>

        {dataLogin ? (
          <div className="header-info">
            <div
              className="balance-badge"
              onClick={() => history.push(Consts.RECHARGE)}
            >
              <div className="balance-icon">₭</div>
              <span className="balance-amount">
                {dataUser?.walletAmount
                  ? formatCurrency(dataUser?.walletAmount)
                  : 0}
              </span>
              <span className="balance-unit">{t("NavKip")}</span>
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <div
                style={{
                  display: "flex",
                  padding: 5,
                  borderRadius: 50,
                  cursor: "pointer",
                }}
                onClick={handleShow}
              >
                <div>
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      (languageFlags[languageLocal] || languageFlags.en)
                    }
                    style={{ height: 20, width: 25 }}
                  />
                </div>
              </div>
            </div>
          </div>
        ) : (
          <button
            className="login-btn"
            onClick={() => history.push(Consts.LOGIN)}
          >
            {t("NaveBarLogin")}
          </button>
        )}
      </header>
      {/* <header className="header">
        <div className="logo">
          <img
            src={process.env.PUBLIC_URL + "/assets/uploads/logo/logo.png"}
            alt="Logo"
            onClick={() => history.push(Consts.PAGE_HOME)}
            style={{
              height: "40px",
            }}
          />
        </div>
        {dataLogin ? (
          <div className="header-info">
            <span className="name">
              {dataUser?.walletAmount
                ? formatCurrency(dataUser?.walletAmount)
                : 0}{" "}
              ກີບ
            </span>
            <div style={{ display: "flex", alignItems: "center" }}>
              <FontAwesomeIcon
                icon={faSearch}
                style={{ marginRight: 5, cursor: "pointer" }}
                onClick={() => setTagsShow(tagsShow ? false : true)}
              />
              <div
                style={{
                  display: "flex",
                  padding: 5,
                  borderRadius: 50,
                  cursor: "pointer",
                }}
                onClick={handleShow}
              >
                <div>
                  <img
                    src={
                      languageLocal === "lo"
                        ? process.env.PUBLIC_URL +
                          "/assets/uploads/logo/lao.svg"
                        : languageLocal === "th"
                        ? process.env.PUBLIC_URL +
                          "/assets/uploads/logo/thai.svg"
                        : process.env.PUBLIC_URL +
                          "/assets/uploads/logo/unit.svg"
                    }
                    style={{ height: 20, width: 25 }}
                  />
                </div>
              </div>
            </div>
          </div>
        ) : (
          <button
            className="header-btn"
            onClick={() => history.push(Consts.LOGIN)}
          >
            ລົງ​ທະ​ບຽນ / ເຂົ້າ​ສູ່​ລະ​ບົບ
          </button>
        )}
      </header> */}
      {tagsShow ? (
        <div style={{ padding: "12px 16px", backgroundColor: "rgba(15, 15, 26, 0.98)", backdropFilter: "blur(20px)", borderBottom: "1px solid rgba(255, 215, 0, 0.1)" }}>
          <Form.Control
            type="text"
            value={inputValue}
            onChange={(e) => {
              setCountTimeSearch(3);
              if (!!e?.target?.value) {
                setLoadingSearch(true);
              } else {
                setLoadingSearch(false);
              }
              setInputValue(e?.target?.value);
            }}
            placeholder={t("SearchNavbar")}
            style={{ height: 50, backgroundColor: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,215,0,0.2)", borderRadius: 12, color: "#fff", fontSize: 15 }}
          />
          {loadingSearch ? (
            <div
              style={{
                width: "100%",
                padding: 10,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Spinner />
            </div>
          ) : (
            ""
          )}
          {dataFilter?.totalGame > 0 || dataFilter?.totalVoucher > 0 ? (
            <div
              style={{
                overflow: "auto",
                maxHeight: "480px",
                marginTop: 10,
                borderRadius: 10,
              }}
            >
              {dataFilter?.dataGame?.map((dataA, indexA) => (
                <div
                  onClick={() => _ClickDetail(dataA, "GAME")}
                  style={{ display: !dataA?.isGameGroup ? "block" : "none" }}
                >
                  <div
                    className="col-12"
                    style={{
                      flexDirection: "row",
                      textAlign: "center",
                      alignItems: "center",
                      backgroundColor: "rgba(255,255,255,0.05)",
                      padding: 10,
                      borderRadius: 10,
                      marginBottom: 6,
                      display: dataA?.activeTime
                        ? fetchDataFromDatabase(dataA?.dueTime)
                        : "flex",
                      transition: "background 0.2s",
                      cursor: "pointer",
                    }}
                  >
                    <div>
                      <img
                        src={URL_IMAGE + dataA?.imageProfile}
                        alt="..."
                        width={80}
                        style={{ borderRadius: 8 }}
                      />
                    </div>
                    <div style={{ width: 14 }}></div>
                    <div style={{ color: "rgba(255,255,255,0.9)", fontSize: 14 }}>
                      {languageLocal === "lo"
                        ? dataA?.name
                        : languageLocal === "th"
                        ? dataA?.nameTh || dataA?.name
                        : dataA?.nameEn || dataA?.name}
                    </div>
                  </div>
                </div>
              ))}

              {dataFilter?.dataVoucher?.map((dataA, indexA) => (
                <div
                  onClick={() => _ClickDetail(dataA, "VOUCHER")}
                  style={{ display: !dataA?.isGameGroup ? "block" : "none" }}
                >
                  <div
                    className="col-12"
                    style={{
                      flexDirection: "row",
                      display: dataA?.activeTime
                        ? fetchDataFromDatabase(dataA?.dueTime)
                        : "flex",
                      textAlign: "center",
                      alignItems: "center",
                      backgroundColor: "rgba(255,255,255,0.05)",
                      padding: 10,
                      borderRadius: 10,
                      marginBottom: 6,
                      cursor: "pointer",
                    }}
                  >
                    <div>
                      <img
                        src={URL_IMAGE + dataA?.imageProfile}
                        alt="..."
                        width={80}
                        style={{ borderRadius: 8 }}
                      />
                    </div>
                    <div style={{ width: 14 }}></div>
                    <div style={{ color: "rgba(255,255,255,0.9)", fontSize: 14 }}>{dataA?.name}</div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            ""
          )}
        </div>
      ) : (
        ""
      )}
      {/* ===== Language Dropdown (Modern) ===== */}
      {show && <div className="lang-dropdown-overlay" onClick={handleClose} />}
      <div className={`lang-dropdown${show ? ' lang-dropdown--open' : ''}`}>
        <div className="lang-dropdown__header">
          <span className="lang-dropdown__title">{t("NavSelectLang")}</span>
        </div>
        <div className="lang-dropdown__list">
          {[
            { code: 'lo', label: 'ລາວ', sub: 'Lao', flag: '/assets/uploads/logo/lao.svg' },
            { code: 'th', label: 'ไทย', sub: 'Thai', flag: '/assets/uploads/logo/thai.svg' },
            { code: 'en', label: 'English', sub: 'English', flag: '/assets/uploads/logo/unit.svg' },
            { code: 'vi', label: 'Tiếng Việt', sub: 'Vietnamese', flag: '/assets/uploads/logo/vietnam.svg' },
            { code: 'zh', label: '中文', sub: 'Chinese', flag: '/assets/uploads/logo/china.svg' },
            { code: 'km', label: 'ខ្មែរ', sub: 'Khmer', flag: '/assets/uploads/logo/cambodia.svg' },
            { code: 'my', label: 'မြန်မာ', sub: 'Myanmar', flag: '/assets/uploads/logo/myanmar.svg' },
            { code: 'id', label: 'Indonesia', sub: 'Indonesian', flag: '/assets/uploads/logo/indonesia.svg' },
          ].map((lang) => (
            <div
              key={lang.code}
              className={`lang-dropdown__item${languageLocal === lang.code ? ' lang-dropdown__item--active' : ''}`}
              onClick={() => changeLanguage(lang.code)}
            >
              <img src={process.env.PUBLIC_URL + lang.flag} alt={lang.label} className="lang-dropdown__flag" />
              <div className="lang-dropdown__text">
                <span className="lang-dropdown__label">{lang.label}</span>
                <span className="lang-dropdown__sub">{lang.sub}</span>
              </div>
              {languageLocal === lang.code && (
                <svg className="lang-dropdown__check" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#ffd700" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
